import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=da351b32&scoped=true&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"
import style0 from "./Consultations.vue?vue&type=style&index=0&id=da351b32&scoped=true&lang=scss&"
import style1 from "./Consultations.vue?vue&type=style&index=1&id=da351b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da351b32",
  null
  
)

export default component.exports